import { React, useState, useRef, useEffect } from "react";
const CricketScoreBoard = ({ eventDetails, scoreboardData }) => {

  const audioRef = useRef(null);
  const [audioSrc, setAudioSrc] = useState("");
  const [enabled, setEnabled] = useState(false);
  const playedAudios = useRef(new Set());
  const [commentryOn, setCommentryOn] = useState(false);
  const [Team1Display, setTeam1Display] = useState(false);
  const [Team2Display, setTeam2Display] = useState(false);

  const handleCommentryCheckbox = (e) => {
    var isOn = e.target.checked;
    setCommentryOn(isOn);
    if (isOn) {
      setEnabled(true);
    } else {
      setEnabled(false);
    }
  };

  const setScoreBoard = async (scoreboardData) => {
    console.log("scoreboardData->", scoreboardData);

    if (scoreboardData?.target === 0 || scoreboardData?.toWin === "") {
      setTeam1Display(true);
      setTeam2Display(false);
    } else {
      setTeam1Display(false);
      setTeam2Display(true);
    }

    let currentBall = scoreboardData?.commentry;
    let sourceUrl = "";
    if (currentBall == "No Run") {
      sourceUrl = "/assets/audio/norun.mp3";
    } else if (currentBall == "BALL CHALU") {
      sourceUrl = "/assets/audio/ballrunning.mp3";
    } else if (currentBall == "OVER CHANGE") {
      sourceUrl = "/assets/audio/over.mp3";
    } else if (currentBall == "SIX") {
      sourceUrl = "/assets/audio/New6Run.mp3";
    } else if (currentBall == "SINGLE" || currentBall == "Single") {
      sourceUrl = "/assets/audio/1run.mp3";
    } else if (currentBall == "2" || currentBall == "Double") {
      sourceUrl = "/assets/audio/2run.mp3";
    } else if (currentBall == "3 Runs" || currentBall == "3") {
      sourceUrl = "/assets/audio/3run.mp3";
    } else if (currentBall == "4 Runs" || currentBall == "Four") {
      sourceUrl = "/assets/audio/4run.mp3";
    } else if (currentBall == "Wide + Four") {
      sourceUrl = "/assets/audio/3run.mp3";
    } else if (currentBall == "Faster") {
      sourceUrl = "/assets/audio/faster.mp3";
    } else if (currentBall == "Spinner") {
      sourceUrl = "/assets/audio/Spinner.mp3";
    } else if (currentBall == "Review") {
      sourceUrl = "/assets/audio/Review.mp3";
    } else if (currentBall == "Wicket" || currentBall == "Out") {
      sourceUrl = "/assets/audio/wicket.mp3";
      //commentry = "Out";
    } else if (currentBall == "Wide Ball") {
      sourceUrl = "/assets/audio/wide.mp3";
    } else if (currentBall == "Bowling Team Review") {
      sourceUrl = "/assets/audio/Review.mp3";
    } else if (currentBall == "Wide + 4") {
      sourceUrl = "/assets/audio/4_Wide.mp3";
    } else if (currentBall == "No Ball") {
      sourceUrl = "/assets/audio/noball.mp3";
    }

    if (sourceUrl != "") {
      setAudioSrc(sourceUrl);
    }
  };

  useEffect(() => {
    setScoreBoard(scoreboardData);
  }, [scoreboardData]); // Empty dependency array

  useEffect(() => {
    if (audioSrc && !playedAudios.current.has(audioSrc)) {
      if (enabled && audioSrc) {
        //console.log("enabled->", enabled);
        //console.log("audioSrc->", audioSrc);
        audioRef.current.src = audioSrc;
        audioRef.current.play();
        playedAudios.current.add(audioSrc);
      } else {
        audioRef.current.src = "";
      }
    }
  }, [audioSrc, enabled]);
  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: "rgb(255, 255, 255)",
        padding: "2px 4px",
        display: "flex",
        flexDirection: "column",
        gap: "1px",
        minHeight: "fit-content",
        margin: "-8px 0px 0px"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <input
            type="checkbox"
            onChange={handleCommentryCheckbox}
            style={{
              width: "14px",
              height: "14px",
              cursor: "pointer",
              margin: "0px"
            }}
          />{" "}
          <span>
            <i
              class="fas fa-volume-mute"
              style={{ display: commentryOn ? "none" : "" }}
            ></i>
            <i
              class="fas fa-volume-up"
              style={{ display: commentryOn ? "" : "none" }}
            ></i>
            <audio ref={audioRef} src="" />
          </span>
        </div>{" "}
        <div
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "rgb(68, 68, 68)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: "1 1 0%"
          }}
        >
          {scoreboardData?.commentry}
        </div>
      </div>{" "}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
          borderTop: "1px solid rgb(240, 240, 240)",
          paddingTop: "4px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            display:
              scoreboardData?.target != "" || scoreboardData?.toWin != ""
                ? ""
                : "none"
          }}
          id="team2"
        >
          <span
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: "rgb(26, 35, 126)"
            }}
          >
            {scoreboardData?.team2Name}
          </span>{" "}
          <span
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: "rgb(34, 34, 34)"
            }}
          >
            {scoreboardData?.team2Score}-{scoreboardData?.team2Wicket}
          </span>{" "}
          <span
            style={{
              fontSize: "13px",
              color: "rgb(102, 102, 102)",
              fontWeight: "500"
            }}
          >
            ({scoreboardData?.team2Over} Over)
          </span>
        </div>{" "}
        <div
          style={{
            display:
              scoreboardData?.target == "" && scoreboardData?.toWin == ""
                ? ""
                : "none"
          }}
          id="team1"
        >
          <span
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: "rgb(26, 35, 126)"
            }}
          >
            {scoreboardData?.team1Name}
          </span>{" "}
          <span
            style={{
              fontSize: "18px",
              fontWeight: "800",
              color: "rgb(34, 34, 34)"
            }}
          >
            {scoreboardData?.team1Score}-{scoreboardData?.team1Wicket}
          </span>{" "}
          <span
            style={{
              fontSize: "13px",
              color: "rgb(102, 102, 102)",
              fontWeight: "500"
            }}
          >
            ({scoreboardData?.team1Over} Over)
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
          <div
            style={{
              background: "rgb(241, 243, 244)",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "700"
            }}
          >
            CRR:{" "}
            <span
              style={{
                color: "rgb(46, 125, 50)",
                display: Team1Display ? "" : "none"
              }}
            >
              {scoreboardData?.team1RunRate}
            </span>
            <span
              style={{
                color: "rgb(46, 125, 50)",
                display: Team2Display ? "" : "none"
              }}
            >
              {scoreboardData?.team2RunRate}
            </span>
          </div>

          <div
            style={{
              background: "rgb(255, 243, 224)",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "700",
              display:
                (scoreboardData?.requiredRunRate != "0") != "" ? "" : "none"
            }}
          >
            RRR:{" "}
            <span
              style={{
                color: "rgb(239, 108, 0)",
                display: scoreboardData?.requiredRunRate != "" ? "" : "none"
              }}
            >
              {scoreboardData?.requiredRunRate}
            </span>
          </div>

          <div
            style={{
              background: "rgb(232, 234, 246)",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "700",
              border: "1px solid rgb(197, 202, 233)",
              display: scoreboardData?.target != "" ? "" : "none"
            }}
          >
            T:{" "}
            <span
              style={{
                color: "rgb(26, 35, 126)",
                display: scoreboardData?.target != "" ? "" : "none"
              }}
            >
              {scoreboardData?.target}
            </span>
          </div>
        </div>
      </div>{" "}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          fontSize: "12px",
          color: "rgb(85, 85, 85)",
          paddingTop: "2px"
        }}
      >
        <div style={{ display: "flex", gap: "4px" }}>
          <span
            style={{
              letterSpacing: "1px",
              fontFamily: "monospace",
              fontWeight: "bold",
              fontSize: "12px"
            }}
          >
            {scoreboardData?.lastSixBalls}
          </span>
        </div>{" "}
        <div
          style={{
            fontWeight: "700",
            color: "rgb(46, 125, 50)",
            fontSize: "13px"
          }}
        >
          {scoreboardData?.toWin}
        </div>
      </div>
    </div>
  );
};

export default CricketScoreBoard;
